export default "__VITE_ASSET__CwrAnWcI__"